import keyMirror from 'keymirror';

const actionTypes = keyMirror({
  SET_CURRENT_TENANT: null,
  SET_CROWDFUNDING_INVESTOR: null,
  SET_CROWDFUNDING_MODAL: null,
});

export default actionTypes;



// WEBPACK FOOTER //
// ./src/redux/actionTypes.js